import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const DMModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'PCNF and PDNF', path: '/dm-m1-s1' },
      { name: 'Rules of Inference', path: '/dm-m1-s2' },
      { name: 'Predicate Calculus', path: '/dm-m1-s3' }
    ],
    'Module 2': [
      { name: 'Algebraic Structures', path: '/dm-m2-s1' }
    ],
    'Module 3': [
      { name: 'Pigeonhole Principle', path: '/dm-m3-s1' },
      { name: 'Principle of Inclusion & Exclusion', path: '/dm-m3-s2' },
      { name: 'Permutation and Combination', path: '/dm-m3-s3' },
      { name: 'Recurrence relation', path: '/dm-m3-s4' }
    ],
    'Module 4': [
      { name: 'POSET', path: '/dm-m4-s1' },
      { name: 'Lattice', path: '/dm-m4-s2' },
      { name: 'Types of lattices', path: '/dm-m4-s3' },
      { name: 'Boolean algebra', path: '/dm-m4-s4' }
    ],
    'Module 5': [
      { name: 'Basics and Terminology of graphs', path: '/dm-m5-s1' },
      { name: 'Isomorphic graphs', path: '/dm-m5-s2' },
      { name: 'Euler and Hamilton', path: '/dm-m5-s3' },
      { name: 'Planar/Non-Planar', path: '/dm-m5-s4' },
      { name: 'Dijkstra Algorithm ', path: '/dm-m5-s5' },
      { name: 'Theorems', path: '/dm-m5-s6' },

    ],
    'Module 6': [
      { name: 'Basics and Terminologies of trees', path: '/dm-m6-s1' },
      { name: 'Minimum Spanning Tree', path: '/dm-m6-s2' },
      { name: 'Theorems', path: '/dm-m6-s3' },

    ],
    'Module 7': [
      { name: 'Chromatic polynomial', path: '/dm-m7-s1' },


    ],

  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Discrete Mathematics</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-DMModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DMModules;
